import {MenuDto, OptionDto} from "../../services/Client";
import {AnyAction} from "redux";
import {IOptionsViewUserSettings} from "../../views/OptionsView/OptionsViewSettings";
import {ITableSort} from "../../utils/SortUtils";
import {ActionTypes} from "./ActionTypes";
import {Dispatch} from "react-redux";
import {IReduxState} from "../IReduxState";
import GeneralActions from "./GeneralActions";

const OptionViewActions = {
    ReceivePSLAreaExtraLinksAction(dto: MenuDto): AnyAction {
        return {type: ActionTypes.RECEIVE_PSL_AREA_EXTRA_LINKS, pslAreaExtraLinks: dto};
    },
    ChangeOptionsViewUserSettings(newSettings: IOptionsViewUserSettings) {
        return {type: ActionTypes.CHANGE_OPTIONSVIEW_USER_SETTINGS, optionsView: newSettings};
    },
    SetOptionTableSort(sortObject: ITableSort): AnyAction {
        return {type: ActionTypes.SET_OPTION_TABLE_SORT, sortObject};
    },
    SetHideEmptyAssignmentsRowsAndColumns(value?: boolean): AnyAction {
        return {type: ActionTypes.SET_HIDE_EMPTY_ASSIGN_ROWS_AND_COLUMNS, value};
    },
    GetOptionIndicators(
        t: reactI18Next.TranslationFunction,
        dto: OptionDto,
        setMessage: (message: string) => void,
        setResult: (references: OptionDto[]) => void) {
        return (dispatch: Dispatch<IReduxState>, getState: () => IReduxState) => {
            const loadingScreenMessage = t('OPTIONS_VIEW:LOAD_INDICATORS');

            setMessage("OPTIONS_VIEW:LOAD_INDICATORS");
            const {client} = getState().general;
            if (!client.GET_optionIndicators(dto).canExecute()) {
                setMessage("GLOBAL:MISSING_ACCESS_RIGHTS");
            }

            dispatch(GeneralActions.AddLoadingMessage(loadingScreenMessage));

            client.GET_optionIndicators(dto).execute()
                .then((result) => {
                    dispatch(GeneralActions.RemoveLoadingMessage(loadingScreenMessage));
                    setMessage("");
                    setResult(result);
                }).catch(() => {
                dispatch(GeneralActions.RemoveLoadingMessage(loadingScreenMessage));

                setMessage("ERRORS:LOAD_INDICATORS_FAIL");
            });
        };
    },
};

export default OptionViewActions;


// WEBPACK FOOTER //
// ./src/redux/actions/OptionViewActions.tsx